import React, { useEffect, useState } from 'react';
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const swiperOptions = (slideCount) => ({
    modules: [Autoplay, Pagination, Navigation],
    slidesPerView: 2,
    spaceBetween: 30,
    speed: 2000,
    autoplay: {
        delay: 9000,
        disableOnInteraction: false,
    },
    loop: slideCount > 2,
    navigation: {
        nextEl: ".swiper-button-next1",
        prevEl: ".swiper-button-prev1"
    },
    pagination: {
        el: ".swiper-dot-style1",
        type: "bullets",
        clickable: true
    },
    breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 20 },
        640: { slidesPerView: 1, spaceBetween: 20 },
        768: { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 }
    }
});

export default function TeamSlider() {
    const [teamData, setTeamData] = useState([]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/faculties/`)
            .then(response => response.json())
            .then(data => setTeamData(data))
            .catch(error => console.error('Error fetching team data:', error));
    }, []);

    return (
        <section className="px-4 py-12 overflow-hidden">
            <div className="mx-auto max-w-7xl">
                <Swiper {...swiperOptions(teamData.length)} className="relative">
                    {teamData.map((member, index) => (
                        <SwiperSlide key={index} className="flex justify-center">
                            <div className="w-full max-w-sm bg-white rounded-2xl shadow-xl border-b-4 border-orange-700 p-6 flex flex-col justify-between h-[250px]">
                                <div>
                                    <h3 className="mb-2 text-lg font-bold text-orange-900 md:text-xl">
                                        Name: <span className="font-medium text-gray-800">{member.name}</span>
                                    </h3>
                                    <hr className="mb-2"/>
                                    <p className="mb-1 text-sm text-gray-700 md:text-base">
                                        <span className="font-semibold">Qualification:</span> {member.qualifications}
                                    </p>
                                    <p className="text-sm text-gray-700 md:text-base">
                                        <span className="font-semibold">Experience:</span> {member.experience}
                                    </p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
}